import { api } from '@/services/api/client';
import { getPaginated, type Paginated } from '@/services/api/paginated';
import type {
  Ticket,
  TicketCounts,
  TicketDetail,
  TicketListQuery,
  TicketPriority,
  TicketStatus,
} from './types';

/**
 * Endpoints kept with the feature rather than in the shared API map: nothing
 * outside the tickets screens calls them.
 */
const BASE = '/tickets';

export const ticketsService = {
  list: (query: TicketListQuery, signal?: AbortSignal): Promise<Paginated<Ticket>> =>
    getPaginated<Ticket>(BASE, { ...query }, signal, 'Could not load tickets.'),

  counts: (signal?: AbortSignal): Promise<TicketCounts> =>
    api.get<TicketCounts>(`${BASE}/counts`, signal ? { signal } : {}),

  get: (id: string, signal?: AbortSignal): Promise<TicketDetail> =>
    api.get<TicketDetail>(`${BASE}/${id}`, signal ? { signal } : {}),

  /** Emails the reply to whoever raised the ticket. */
  reply: (id: string, body: { body: string; status?: TicketStatus }): Promise<TicketDetail> =>
    api.post<TicketDetail>(`${BASE}/${id}/comments`, body),

  /** Resolving or closing emails the lab. */
  update: (
    id: string,
    body: { status?: TicketStatus; priority?: TicketPriority },
  ): Promise<TicketDetail> => api.patch<TicketDetail>(`${BASE}/${id}`, body),
};
